export const sendMetrics = (type: string, id: MerticNames) => {
  (window as any).ym(100832239, type, id);
};

export const enum MerticNames {
  registrationClick = "registrationClick",
  startReadStoryClick = "startReadStoryClick",
  startReadAloudStoryClick = "startReadAloudStoryClick",
  endReadStory = "endReadStory",
  endStoryWithoutContinue = "endStoryWithoutContinue",
  bookmarkStart = "bookmarkStart",
  telegramRedirect = "telegramRedirect"
}
